import {createSlice} from "@reduxjs/toolkit";
import {fetchThemes} from "./themeThunks";

export const themesSlice = createSlice({
    name: 'themes',
    initialState: {
        themes: [],
        loading: true,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchThemes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchThemes.fulfilled, (state, action) => {
                state.loading = false;
                state.themes = action.payload;
            })
            .addCase(fetchThemes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
})
export default themesSlice.reducer;